import React from 'react';
import MTicketEcoFriendlyLabel from "@Route/components/MTicket/MTicketEcoFriendlyLabel";
import IconMTicketQrShifted from "@Icons/IconMTicketQrShifted";
import IconPaperTicket from "@Icons/IconPaperTicket";
import NotificationExpandable from "../../features/notification/components/NotificationExpandable";
import {useTranslation} from "@Translation/hooks/useTranslation";
import {RouteTransferTypeKeys} from "@Route/features/transportType/types/routeTransferType.type";
import {routeTransferTypes} from "@Route/features/transportType/constants/routeTransferTypes";

interface TicketTypeProps {
    hasMTicket: boolean,
    routeType: RouteTransferTypeKeys,
}

const TicketType = ({hasMTicket, routeType}: TicketTypeProps) => {
    const {
        ticket_has_to_be_printed: paperTicketDescription,
    } = useTranslation("search_results")

    const mTicketDescription = useTranslation(`search_results.has_mticket_desc.${routeTransferTypes[routeType]}`)

    if (hasMTicket) {
        return (
            <NotificationExpandable
                icon={<IconMTicketQrShifted/>}
                title={<MTicketEcoFriendlyLabel/>}
                descriptionText={mTicketDescription}
            />
        )
    }
    return (
        <NotificationExpandable
            icon={<IconPaperTicket/>}
            title="Paper ticket"
            descriptionText={paperTicketDescription}
        />
    )
}

export default TicketType;